import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Grid, Header, Image, Message, Segment } from 'semantic-ui-react';
import logo from '../assets/svgs/funeral-live-logo.png';

import { resetPassword } from '../actions/userActions';


const RegistrationPage = (props) => {
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const token = props.match.params.token;

  return (
  <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
    <Grid.Column style={{ maxWidth: 600 }}>
      <Header as='h2' color='black' textAlign='center'>
        <Image src={logo} style={{ width: 150 }} /> Complete your registration
      </Header>
        <Segment stacked>
          <Input
            fluid
            icon='lock'
            iconPosition='left'
            placeholder='Password'
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Input
            fluid
            icon='lock'
            iconPosition='left'
            placeholder='Password Confirmation'
            type='password'
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
          />

          <Button
            color='blue'
            fluid
            size='large'
            disabled={(!password || !passwordConfirmation) || (password !== passwordConfirmation)}
            onClick={() => props.resetPassword(token, password, props.history)}>
              Reset Password
          </Button>
        </Segment>
    </Grid.Column>
  </Grid>
  );
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = {
  resetPassword,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationPage);
